














































import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import { ImportExport } from "@/classes/importExport/ImportExport";
import { LaborExportClass } from "@/services/LaborExportClass";
import {
  Export as IExport,
  ExportStatusEnum
} from "@/api-v2/import-export-2/models/export";
import LaborExportDetailInfo from "@/components/export/LaborExportDetailInfo.vue";

@Component({
  components: { LaborExportDetailInfo, TextField, CBlock, CPage }
})
export default class ExportView extends Vue {
  isLoading: boolean = false;
  isDetailLoading: boolean = false;
  item!: IExport;

  data() {
    return {
      item: undefined
    };
  }

  getStatus(status: ExportStatusEnum) {
    return LaborExportClass.getExportStatus(status);
  }

  async getDetailInfo() {
    try {
      this.isDetailLoading = true;
      this.item = await ImportExport.getExportById(this.$route.params.id);
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isDetailLoading = false;
    }
  }

  async getExport() {
    try {
      this.isLoading = true;
      this.item = await ImportExport.getExportById(this.$route.params.id);
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.getExport();
  }
}
